export default __webpack_public_path__ + "static/pragicts-secops-services-data-protection-security-12ed8d97a968672625c22670f2854d27.jpg";